export default __webpack_public_path__ + "static/media/tpc_calc_price_tag.eec156bb.svg";